import styled from 'styled-components';

const HorizontalSpacingWrapper = styled.div`
  margin: auto;
  max-width: 66rem;
`;

export default HorizontalSpacingWrapper;
